import copyToClipboardView from './copyToClipboardComponent.html';
import './copyToClipboardComponent.css';

export function copyToClipboardComponent() {
	return {
		bindings: {
			copy: '<',
			display: '<?',
		},
		controllerAs: 'vm',
		controller: copyToClipboardComponentCtrl,
		template: copyToClipboardView,
	};
}

export class copyToClipboardComponentCtrl {
	constructor($timeout, clipboard) {
		'ngInject';
		this.$timeout = $timeout;
		this.clipboard = clipboard;
	}

	copyToClipboard() {
		this.isConfirming = true;
		this.$timeout(() => (this.isConfirming = false), 1500);
		this.clipboard.copyText(this.copy);
	}
}
